<template>
  <v-layout row>
    <v-flex xs12>
      <v-sheet elevation="1">
        <v-container fluid>
          <v-layout row>
            <v-flex xs12 v-if="origId == null">
              <h3>Nouvel article</h3>
            </v-flex>
          </v-layout>
          <v-flex xs12>
            <v-text-field
              label="Titre *"
              v-model="newArticleTitle"
            ></v-text-field>
            <wysiwyg v-model="newArticleContent"></wysiwyg>
          </v-flex>
          <v-flex xs12>
            <DropZone
              type="files"
              :value="files"
              edit-mode="true"
              :target="origId"
              @add="refreshDocs"
              @remove="removeFile"
            ></DropZone>
          </v-flex>
          <v-layout row>
            <v-btn color="red" @click="deleteKbItem" v-if="origId"
              >Supprimer</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn flat color="grey" @click="$emit('cancel')">Annuler</v-btn>
            <v-btn color="primary" v-on:click="createKbItem()">Publier</v-btn>
          </v-layout>
        </v-container>
      </v-sheet>
    </v-flex>
    <v-snackbar v-model="showError"> {{ errorMessage }}</v-snackbar>
  </v-layout>
</template>
<script>
import { fetchHil } from "../../utils";
import DropZone from "../commons/DropZone";

export default {
  components: { DropZone },
  props: ["origTitle", "origContent", "origId"],
  data() {
    return {
      newArticleTitle: "",
      newArticleContent: "",
      showError: false,
      errorMessage: "",
      files: [],
    };
  },
  mounted() {
    if (this.origTitle != null) {
      this.newArticleTitle = this.origTitle;
    }
    if (this.origContent != null) {
      this.newArticleContent = this.origContent;
    }
    this.refreshDocs();
  },
  methods: {
    async removeFile(file) {
      await fetchHil(`/cache/${file._id}`, { method: "DELETE" });
      this.refreshDocs();
    },
    async refreshDocs() {
      const resp = await fetchHil(`/cache/for/${this.origId}`);
      this.files = await resp.json();
    },
    async deleteKbItem() {
      await fetchHil(`/kbitem/${this.origId}`, {
        method: "DELETE",
      });
      this.$emit("update");
    },
    async createKbItem() {
      if (this.newArticleTitle === "") {
        this.errorMessage = "Le titre est obligatoire";
        this.showError = true;
        return;
      }
      try {
        await fetchHil(
          this.origId != null ? `/kbitem/${this.origId}` : `/kbitem`,
          {
            method: this.origId != null ? "PUT" : "POST",
            body: {
              title: this.newArticleTitle,
              content: this.newArticleContent,
            },
          }
        );
      } catch (e) {
        console.error(e);
        this.errorMessage = "Une erreur a eu lieu";
        this.showError = true;
        return;
      }
      this.errorMessage = "";
      this.newArticleContent = "";
      this.newArticleTitle = "";
      this.$emit("update");
    },
  },
};
</script>
